/** Оплаты сделки — ровно то, что отдаёт `GET /api/deals/{id}/payments`. */
import { apiFetch } from "@/lib/api";

export type Receipt = { label: string; at: string | null; url: string | null; amount: number | null };

export type Payment = {
  id: number;
  at: string | null;
  amount: number;
  status: string | null;
  status_color: string | null;
  /** Статус из «оплачено» (`sPayment_status.isPayed`). */
  paid: boolean;
  sys: string | null;
  category: string | null;
  kassa: string | null;
  city: string | null;
  email: string | null;
  contract_id: number | null;
  who: string | null;
  confirmed: { at: string | null; who: string | null } | null;
  cancelled: { at: string | null; who: string | null; comment: string | null } | null;
  receipts: Receipt[];
};

export type DealPayments = {
  payments: Payment[];
  totals: {
    paid: number;
    waiting: number;
    cancelled: number;
    returned: number;
    contract: number;
    due: number;
    deal_sum: number;
    deal_paid: number;
    mismatch: boolean;
  };
};

export function loadDealPayments(id: number): Promise<DealPayments> {
  return apiFetch<DealPayments>(`/api/deals/${id}/payments`);
}
